export const timeOutBipInput = 150